<template>
  <div>
    <a-form :form="form" :hideRequiredMark="true">
      <a-form-item
        label="手机号"
        :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
        :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
      >
        <a-input
          class="input"
          autocomplete="false"
          placeholder="手机号"
          v-decorator="[
            'certPhone',
            {
              rules: [
                {
                  required: true,
                  pattern: /^1[123456789]\d{9}$/,
                  message: '请输入正确的手机号'
                }
              ],
              validateTrigger: ['change', 'blur']
            }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="真实姓名"
        :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
        :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
      >
        <a-input
          class="input"
          autocomplete="false"
          placeholder="真实姓名"
          v-decorator="[
            'certName',
            {
              rules: [{ required: true, message: '请输入真实姓名' }],
              validateTrigger: ['change', 'blur']
            }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="身份证"
        :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
        :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
      >
        <a-input
          class="input"
          autocomplete="false"
          placeholder="请填写身份证"
          v-decorator="[
            'certNo',
            {
              rules: [
                { required: true, message: '请填写身份证' },
                { validator: this.handleCertNo }
              ],
              validateTrigger: ['change', 'blur']
            }
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item class="ok_btn">
        <a-button
          type="primary"
          htmlType="submit"
          :loading="step1Loading"
          @click.stop.prevent="handleSubmit"
        >
          认证
        </a-button>
      </a-form-item>
    </a-form>
    <a-modal
      title="人脸验证"
      :width="640"
      :visible="visible"
      :maskClosable="false"
      :footer="false"
      @cancel="handleCancel"
    >
      <div
        style="display: flex; flex-direction: column; gap: 12px; align-items: center"
      >
        <img :src="qrCode" style="width: 320px; height: 320px" />
        <span>请用支付宝扫码进行人脸认证</span>
        <a-button
          type="primary"
          :loading="step2Loading"
          @click="confirmFaceVertify"
        >
          已识别完成
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { certifyPersonInfo, confrimFaceSuccess } from "@api";
import QRCode from "qrcode";
export default {
  props: {
    account: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      vertifyRes: {},
      visible: false,
      step1Loading: false,
      step2Loading: false,
      qrCode: "",
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000"
      }
    };
  },
  methods: {
    removeError() {
      this.form.resetFields();
    },
    handleSubmit() {
      const {
        form: { validateFields }
      } = this;

      validateFields((err, values) => {
        if (!err) {
          console.log("[values] ---> ", values);
          this.step1Loading = true;
          certifyPersonInfo(values).then(res => {
            this.step1Loading = false;
            console.log("[validateFields res] ---> ", res);
            if (res.success) {
              if (res.data.hasCertify) {
                this.$message.success("验证完成");
                this.$emit("vertifySuccess");
              } else {
                this.vertifyRes = res.data;
                this.visible = true;
                this.$nextTick(async () => {
                  this.qrCode = await QRCode.toDataURL(
                    this.vertifyRes.certifyUrl
                  );
                });
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    async confirmFaceVertify() {
      this.step2Loading = true;
      const res = await confrimFaceSuccess(this.vertifyRes);
      this.step2Loading = false;
      console.log("[res] ---> ", res);
      if (res.data) {
        this.$message.success("验证完成");
        this.$emit("vertifySuccess");
      } else {
        this.$message.info('未检测到人脸识别成功！');
      }
    },
    handleCancel() {
      this.visible = false;
      this.vertifyRes = {};
    },
    isValidIdCard(id) {
      // 1. 长度必须为18
      if (!/^\d{17}[\dXx]$/.test(id)) {
        return false;
      }
      return true
    },
    handleCertNo(rule, value, callback) {
      const checkRes = this.isValidIdCard(value);
      if (!checkRes) callback(new Error("身份证填写不对，请检查"));
      callback();
    }
  },
  // watch: {
  //   account: {
  //     handler(newVal) {
  //       console.log("[newVal] ---> ", newVal);
  //       this.$nextTick(() => {
  //         this.form.certPhone = newVal.mobile;
  //       });
  //     }
  //   },
  //   deep: true,
  //   immediate: true
  // }
};
</script>
<style lang="less" scoped>
.input {
  width: 280px;
  height: 32px;
}
.ok_btn {
  margin-left: 130px;
}
</style>
